module.exports = __webpack_public_path__ + "img/4acfd8f.jpg";